export const DESKTOP_NUMBER_IMAGE_SIZE = 138;
export const MOBILE_NUMBER_IMAGE_SIZE = 74;

export const DESKTOP_BENEFITS_IMAGE_SIZE = 194;
export const MOBILE_BENEFITS_IMAGE_SIZE = 74;
